import React, { Component } from 'react';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withViewport } from '../../util/contextHelpers';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { CategoriesEn, Categories } from '../../categories';
import CategoryList  from './CategoryList';
import css from './CategoriesPage.module.css';
import {getListingsById} from "../../ducks/marketplaceData.duck";
import unionWith from "lodash/unionWith";
import uniqBy from "lodash/uniqBy";
import {isScrollingDisabled, manageDisableScrolling} from "../../ducks/UI.duck";
import Banner  from './Banner';

import config from '../../config';

import PropTypes from 'prop-types';

const ONE_COLUMN_SCREEN_WIDTH = 900;
const THREE_COLUMN_SCREEN_WIDTH = 1260;
const FOUR_COLUMN_SCREEN_WIDTH = 1660;


export class CategoriesPageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reload: false
    };
  }


  render() {
    const { listings, viewport } = this.props;


    const currentLocale = config.locale;
    let eventifyCategories;

    if(currentLocale === "lv") {
      eventifyCategories = Categories;
    } else {
      eventifyCategories = CategoriesEn;
    }


    const isOneColumnLayout = viewport.width <= ONE_COLUMN_SCREEN_WIDTH;
    const isTwoColumnLayout = viewport.width > ONE_COLUMN_SCREEN_WIDTH && viewport.width < THREE_COLUMN_SCREEN_WIDTH;
    const isThreeColumnLayout = viewport.width >= THREE_COLUMN_SCREEN_WIDTH && viewport.width < FOUR_COLUMN_SCREEN_WIDTH;
    const isFourColumnLayout = viewport.width >= FOUR_COLUMN_SCREEN_WIDTH;

    let sliceCounter = isOneColumnLayout ? 2 : isTwoColumnLayout ? 4 : isThreeColumnLayout ? 6 : isFourColumnLayout ? 8 : 2;

    const firstCategoriesPatch = eventifyCategories.slice(0, sliceCounter);
    const secondCategoriesPatch = eventifyCategories.slice(sliceCounter, eventifyCategories.length);
    const categoriesListFirstPatch = firstCategoriesPatch.map(c => (
      <div key={c.id} className={css.categoryBigger}>
        <CategoryList key={c.id} id={c.id} cat={c} listings={listings}></CategoryList>
      </div>
    ));

    const categoriesListSecondPatch = secondCategoriesPatch.map(c => (
      <div key={c.id} className={css.categoryBigger}>
        <CategoryList key={c.id} id={c.id} cat={c} listings={listings}></CategoryList>
      </div>
    ));

    return (
      <StaticPage
        title="Visas eventify kategorijas"
        schema={{
          '@context': 'http://schema.org',
          '@type': 'CategoriesPage',
          description: 'Visas eventify kategorijas',
          name: 'Visas eventify kategorijas',
        }}
      >
        <LayoutSingleColumn>
          <LayoutWrapperTopbar>
            <TopbarContainer />
          </LayoutWrapperTopbar>

          <LayoutWrapperMain className={css.staticPageWrapper}>
            <h2 className={css.pageTitle}>
              <FormattedMessage id="CategoriesPage.title" values={{yellowText: <eventify-yellow>eventify</eventify-yellow>}}/>
            </h2>
            <div className={css.categories}>{categoriesListFirstPatch}</div>
            <Banner />
            <div className={css.categories}>{categoriesListSecondPatch}</div>

          </LayoutWrapperMain>

          <LayoutWrapperFooter>
            <Footer />
          </LayoutWrapperFooter>
        </LayoutSingleColumn>
      </StaticPage>
    );
  }
}

CategoriesPageComponent.defaultProps = {
  listings: [],
};

const { number, shape } = PropTypes;

CategoriesPageComponent.propTypes = {
  // form withViewport
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,

};

const mapStateToProps = state => {
  const {
    currentPageResultIds,
    pagination,
    searchInProgress,
    searchListingsError,
    searchParams,
    searchMapListingIds,
    activeListingId,
  } = state.CategoriesPage;

  const uniqCurrentPageResultIds = uniqBy(currentPageResultIds, (e) => {
    return e.uuid;
  });

  const pageListings = getListingsById(state, uniqCurrentPageResultIds);
  const mapListings = getListingsById(
    state,
    unionWith(uniqCurrentPageResultIds, searchMapListingIds, (id1, id2) => id1.uuid === id2.uuid)
  );

  return {
    listings: pageListings,
    mapListings,
    pagination,
    scrollingDisabled: isScrollingDisabled(state),
    searchInProgress,
    searchListingsError,
    searchParams,
    activeListingId,
  };
}

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

const CategoriesPage = compose(
  withRouter,
  withViewport,
  connect(mapStateToProps, mapDispatchToProps)
)(CategoriesPageComponent);


export default CategoriesPage;
